/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { FileField as FormFileField } from '../../apiForm/form/input';

export default function FileField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormFileField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
    />
  );
}
